<template>
    <svg v-once aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check-circle" class="svg-inline--fa fa-check-circle fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 768">
        <defs>
            <marker id="arrow" markerWidth="2" markerHeight="2" refX="0" refY="1" orient="auto" markerUnits="strokeWidth">
                <path d="M0,0 L0,2 L2,1 z" :fill="color" />
            </marker>
        </defs>
        <path :fill="color" d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"></path>
        <path fill="none" stroke-linecap="round" :stroke="color" d="M200 450 C200 550, 200 550, 128 600" stroke-width="100px" marker-end="url(#arrow)"></path>
        <path fill="none" stroke-linecap="round" :stroke="color" d="M312 450 C312 550, 312 550, 384 600" stroke-width="100px" marker-end="url(#arrow)"></path>
    </svg>
</template>

<script>
    export default {
        props: {
            color: String
        },
        data() {
            return {
            };
        }
    }
</script>

<style></style>